import { Component, OnInit } from '@angular/core';
import { PublisherService } from '../../../../core/services/publisher.service';
import { OktaService } from '../../okta.service';
import {
  CacheConstant,
  OktaOperationType,
  CacheDuration
} from '../../../../core/constants/app.constant';
import { OktaOperation } from '../../okta-operation';
import { HttpError } from '../../../../shared/models/http-error';
import { AppUtilService } from '../../../../core/utils/app-util.service';
import { OktaRoutes } from '../../../../core/constants/routes.constant';
import { OktaConstant } from '../../okta.constant';
import { BaseComponent } from '../../../../app.base.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppCacheService } from '../../../../core/services/cache/app-cache.service';
import { AppConfigService } from '../../../../core/services/init/app-config.service';

@Component({
  selector: 'par-answer',
  templateUrl: './answer.component.html',
  styleUrls: ['./answer.component.scss']
})
export class AnswerComponent extends BaseComponent implements OnInit {
  /***************Properties***************/
  websiteName: string = this.cache.get(CacheConstant.Env_Properties).theme;
  private operation: OktaOperation = null;
  security: any = {
    question: '',
    answer: '',
    buttonAction: '',
    errorMessage: ''
  };
  /***************Properties***************/

  /***************Constructor***************/
  constructor(private oktaService: OktaService, 
    deviceDetectorService: DeviceDetectorService,
    private cache: AppCacheService,
    private appConfig: AppConfigService) {
    super(deviceDetectorService, cache, appConfig);
  }

  ngOnInit() {
    PublisherService.changeBannerHeader('Answer Security Question');
    this.operation = AppUtilService.cache.get(CacheConstant.Okta_Operation);

    if (this.operation && this.operation.data && this.operation.data.verified) {
      this.setDefaults();
    } else {
      AppUtilService.redirectToHome();
    }
  }
  /***************Constructor***************/

  /***************Component Methods***************/

  onCancelClick() {
    // AppUtilService.redirectToHome();
    if (!this.isMobileDevice()) {
      AppUtilService.redirectToHome();
    } else {
      AppUtilService.redirectToHomeMobile();
    }
  }

  onSecurityQuestionSubmit() {
    if (!this.security.answer) {
      this.security.errorMessage =
        OktaConstant.Messages.SecurityAnswerRequiredMesssage;
      return;
    }

    this.security.errorMessage = '';

    this.oktaService
      .verifySecurityAnswer(
        this.security.answer,
        this.operation.data.stateToken
      )
      .subscribe((response: any) => {
        if (!response.hasError) {
          this.resolveAnswerResponse(response);
        } else {
          this.security.errorMessage = AppUtilService.resolveErrorResponse(
            response as HttpError
          ).messageText;
          this.security.answer = null;
        }
      });
  }

  /***************Component Methods***************/

  /***************Private Methods***************/

  private setDefaults() {
    AppUtilService.cache.remove(CacheConstant.Okta_Operation);
    this.security.question = this.operation.data.recoveryQuestion;

    switch (this.operation.type) {
      case OktaOperationType.ForgotPassword:
        this.security.buttonAction = 'Reset Password';
        break;

      case OktaOperationType.UnlockAccount:
        this.security.buttonAction = 'Unlock Account';
        break;

      default:
        break;
    }
  }

  private resolveAnswerResponse(response) {
    let urlToNavigate = '';

    switch (this.operation.type) {
      case OktaOperationType.ForgotPassword:
        urlToNavigate = OktaRoutes.ResetPassword;
        this.operation.data = response;
        AppUtilService.cache.set(
          CacheConstant.Okta_Operation,
          this.operation,
          CacheDuration.OneMinute
        );
        break;

      case OktaOperationType.UnlockAccount:
        urlToNavigate = '/';
        AppUtilService.message.success(
          OktaConstant.Messages.AccountUnlockedSuccessMesssage
        );
        break;

      default:
        break;
    }

    AppUtilService.router.navigate([urlToNavigate]);
  }

  /***************Private Methods***************/
}
